import { copyText, exportUrl, fetchMarkdown } from "../lib/md";
import { useAnnounce } from "./announce";

/** Copy MD / Download MD — present on every page. */
export function MdButtons({ page, params = {} }: { page: string; params?: Record<string, string | number | undefined> }) {
  const announce = useAnnounce();
  return (
    <span className="md-buttons">
      <button
        type="button"
        data-testid="copy-md"
        aria-label="Copy Markdown"
        onClick={async () => {
          try {
            await copyText(await fetchMarkdown(page, params));
            announce("Markdown copied");
          } catch (e) {
            announce(`Copy failed: ${(e as Error).message}`, "error");
          }
        }}
      >
        Copy MD
      </button>
      <a className="button" data-testid="download-md" aria-label="Download Markdown" href={exportUrl(page, params, true)}>
        Download MD
      </a>
    </span>
  );
}
